const CURRENT_TOKEN_KEY = "auth_token";

export const getToken = () => {
  const tokenFromStorage = localStorage.getItem(CURRENT_TOKEN_KEY);

  return tokenFromStorage || "";
};
